import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { AlertService } from '../shared/toastService/alert.service'
import { TranslateService } from '@ngx-translate/core';
import * as emailjs from 'emailjs-com';
import { environment } from '../../environments/environment'

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

  submitted = false;
  errorMsg: string;
  contactForm: FormGroup = new FormGroup({
    name: new FormControl(''),
    email: new FormControl('',[
      Validators.required,
      Validators.email
    ]),
    phone: new FormControl('',[
      Validators.pattern('^[0-9 ]*$')
    ]),
    commentary: new FormControl('', [
      Validators.required,
      Validators.maxLength(500)])
  });
  
  constructor(
    private httpClient: HttpClient,
    private alertService: AlertService,
    private translateService: TranslateService,
    ) { }

  ngOnInit() {
     this.translateService.get('contactPage.sendError').subscribe(value => { this.errorMsg = value; } );
  }

  get f() { return this.contactForm.controls; }
  
  contact(){
    this.submitted = true;

    if (this.contactForm.valid) {

      const templateParams = this.contactForm.value;

      emailjs.send(environment.EMAIL_JS_SERVICE_ID, environment.EMAIL_JS_CONTACT_TEMPLATE, templateParams, environment.EMAIL_JS_USER_ID)
	    .then((response) => {
        this.alertService.success(this.translateService.instant('contactPage.sendSuccess'));
	    }, (err) => {
        this.alertService.error(this.translateService.instant('contactPage.sendError'));
	    });

    }
    
  }

}
